import { forwardRef } from 'react';
import {
  FormControlLabel,
  Radio as MuiRadio,
  RadioProps as MuiRadioProps,
  RadioGroup as MuiRadioGroup,
  RadioGroupProps as MuiRadioGroupProps,
  styled,
} from '@mui/material';
import { RADIO_DS_ICON, radioDsRootStyles } from './dsRadio';

/**
 * 공통 라디오. 스타일은 `./dsRadio`.
 *
 * 테마에도 같은 스타일이 걸려 있는데 여기서 또 거는 이유는, 테마에만 맡기면 테마가
 * 늦게 갱신되거나 다른 ThemeProvider 밑에 놓일 때 MUI 기본 라디오로 돌아가기 때문.
 */

const StyledRadio = styled(MuiRadio)(radioDsRootStyles);

export type RadioV2Props = MuiRadioProps;

export const RadioV2 = forwardRef<HTMLButtonElement, RadioV2Props>(
  (props, ref) => (
    <StyledRadio
      ref={ref}
      icon={RADIO_DS_ICON}
      checkedIcon={RADIO_DS_ICON}
      {...props}
      disableRipple
    />
  ),
);

RadioV2.displayName = 'RadioV2';

/* ---------- options 패턴 (기존 Radio와 같은 시그니처) ---------- */

type Option = { readonly value: string; readonly label: string };

export type RadioGroupV2Props = {
  readonly options: Option[];
  readonly disabled?: boolean;
} & MuiRadioGroupProps;

export const RadioGroupV2 = forwardRef<HTMLDivElement, RadioGroupV2Props>(
  ({ options, disabled, sx, ...field }, ref) => (
    <MuiRadioGroup
      {...field}
      ref={ref}
      sx={{
        '.MuiButtonBase-root': { display: 'flex', margin: 0, padding: 0 },
        '.MuiFormControlLabel-root': {
          padding: 0,
          margin: '0 24px 0 0',
          gap: '8px',
        },
        input: { width: 1, height: 1 },
        ...sx,
      }}
    >
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={<RadioV2 disabled={disabled} />}
          label={option.label}
        />
      ))}
    </MuiRadioGroup>
  ),
);

RadioGroupV2.displayName = 'RadioGroupV2';

export default RadioV2;
